import { forwardRef, type SelectHTMLAttributes } from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

export const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  ({ className, children, ...props }, ref) => (
    // rc115 — min-w-0/max-w-full: un <select> nativo tiene min-width
    // intrínseco = su opción más larga; en grids/flex del alta eso
    // desbordaba el modal en móvil. Aquí se capa para TODOS los diálogos.
    <div className="relative min-w-0 max-w-full">
      <select
        ref={ref}
        className={cn(
          "flex h-8 w-full max-w-full appearance-none rounded-md border border-input bg-background px-3 pr-8 py-1 text-sm",
          "ring-offset-background",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1",
          "disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        {...props}
      >
        {children}
      </select>
      <ChevronDown className="pointer-events-none absolute right-2 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-muted-foreground" />
    </div>
  )
);
Select.displayName = "Select";
